/**
 * <surisa-programa-calculo> — registro de solicitudes del programa de cálculo.
 *
 * Mismo patrón dual-write que el formulario de contacto, sin adjuntos: al enviar,
 * primero registra la solicitud como metaobject `contact_submission` vía el
 * Cloudflare Worker `surisa-contacto` (?action=submit, panel en Admin → Contenido
 * → Metaobjetos) y después deja seguir el submit nativo de {% form 'contact' %}
 * para que el email a surisa@ llegue como siempre.
 *
 * Si el worker falla o no responde en 6 s, el formulario nativo se envía igual
 * (el email nunca se pierde; solo se perdería la entrada del panel).
 *
 * Particularidades de esta landing:
 *   - familia FIJA y no editable: se toma de data-familia (no de un campo).
 *   - detalle OPCIONAL: el worker exige `detalle` no vacío para crear el
 *     metaobject, así que si el usuario lo deja en blanco se envía
 *     data-detalle-fallback. El email nativo va con el body real (vacío o no).
 *
 * Config vía data-attributes (poblados desde schema settings en Liquid):
 *   data-endpoint          URL del worker (sin query string)
 *   data-familia           valor fijo de "Familia de producto"
 *   data-detalle-fallback  detalle a registrar cuando el campo está vacío
 *
 * Setup completo: docs/ARCHITECTURE_contacto_uploads.md
 */
(function () {
  'use strict';

  if (customElements.get('surisa-programa-calculo')) return;

  class SurisaProgramaCalculo extends HTMLElement {
    connectedCallback() {
      this.endpoint = (this.dataset.endpoint || '').replace(/\/+$/, '');
      this.familia = this.dataset.familia || '';
      this.detalleFallback = this.dataset.detalleFallback || '';
      this.form = this.querySelector('form');
      if (!this.endpoint || !this.form) return;

      var self = this;
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }

    fieldValue(name) {
      var el = this.form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    onSubmit(e) {
      if (this.submitted) return; // segunda pasada: dejar pasar el submit nativo
      e.preventDefault();

      var self = this;
      var detalle = (this.fieldValue('contact[body]') || '').trim() || this.detalleFallback;
      var payload = {
        empresa: this.fieldValue('contact[Empresa]'),
        persona: this.fieldValue('contact[Persona de contacto]'),
        email: this.fieldValue('contact[email]'),
        familia: this.familia,
        detalle: detalle,
        origen: this.fieldValue('contact[Origen]'),
      };

      // Registrar en el panel (metaobject) con timeout corto; pase lo que pase,
      // el formulario nativo se envía después (el email nunca se bloquea).
      var register = fetch(this.endpoint + '?action=submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).catch(function (err) { console.error('[programa-calculo] submit', err); });

      var timeout = new Promise(function (resolve) { setTimeout(resolve, 6000); });

      Promise.race([register, timeout]).then(function () {
        self.submitted = true;
        if (typeof self.form.requestSubmit === 'function') {
          self.form.requestSubmit();
        } else {
          self.form.submit();
        }
      });
    }
  }

  customElements.define('surisa-programa-calculo', SurisaProgramaCalculo);
})();
